/**
* Project janux-vuejs-seed
* Created by hielo on 2018-05-08
*/

<template lang="pug">
div
	// v-jnx-toolbar(:sectionTitle="sectionTitle")
	v-e24-nav-bar
	// v-jnx-slide-in
</template>

<script>
export default {
	name: 'e24-header',
	props: ['sectionTitle']
}
</script>



// WEBPACK FOOTER //
// ../../easytitle24-2.x-common/components/header.vue